import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { Dictionary } from "lodash";

@Component({
    selector: "rl-security-policy-cell",
    templateUrl: "./security-policy-cell.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./security-policy-cell.component.scss"]
})
export class SecurityPolicyCellComponent {
	@Input()
	rightFlag: number;

	@Input()
	description: string;

	@Input()
	rightStatuses: Dictionary<number> = {};

	@Input()
	readonly = false;

	@Output()
	onChange: EventEmitter<number> = new EventEmitter<number>();

    constructor() { }

	get statusLabel() {
		const status = this.rightStatuses?.[this.rightFlag] ?? 0;
		if (status > 0) {
			return "Allow";
		}
		return status < 0 ? "Deny" : "Neutral";
	}

	onClick() {
		if (this.readonly) {
			return;
		}
		this.onChange.emit(this.rightFlag);
	}
}